module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tablePagination && _vm.tablePagination.last_page > 1) ? _c('nav', {
    class: ['pagination', _vm.location]
  }, [_c('a', {
    class: ['pagination-previous', _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.prevText)
    },
    on: {
      "click": function($event) {
        _vm.loadPage('prev')
      }
    }
  }), _vm._v(" "), _c('a', {
    class: ['pagination-next', _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.nextText)
    },
    on: {
      "click": function($event) {
        _vm.loadPage('next')
      }
    }
  }), _vm._v(" "), _c('ul', {
    class: [_vm.css.listClass]
  }, [(_vm.totalPagesLessThanWindowSize) ? _vm._l((_vm.totalPage), function(n) {
    return _c('li', [_c('a', {
      class: [_vm.css.linkClass, _vm.isCurrentPage(n) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(n)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(n)
        }
      }
    })])
  }) : [_c('li', [_c('a', {
    class: [_vm.css.linkClass, _vm.isOnFirstPage ? _vm.css.disabledClass : ''],
    on: {
      "click": function($event) {
        _vm.loadPage(1)
      }
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('span', {
    class: _vm.css.ellipsisClass
  }, [_vm._v("…")])]), _vm._v(" "), _vm._l((_vm.windowSize - 2), function(n) {
    return _c('li', [_c('a', {
      class: [_vm.css.linkClass, _vm.isCurrentPage(_vm.windowStart + n) ? _vm.css.activeClass : ''],
      domProps: {
        "innerHTML": _vm._s(_vm.windowStart + n)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(_vm.windowStart + n)
        }
      }
    })])
  }), _vm._v(" "), _c('li', [_c('span', {
    class: _vm.css.ellipsisClass
  }, [_vm._v("…")])]), _vm._v(" "), _c('li', [_c('a', {
    class: [_vm.css.linkClass, _vm.isOnLastPage ? _vm.css.disabledClass : ''],
    domProps: {
      "innerHTML": _vm._s(_vm.totalPage)
    },
    on: {
      "click": function($event) {
        _vm.loadPage(_vm.totalPage)
      }
    }
  })])]], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-769ba858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BulmaPagination.vue
// module id = 245
// module chunks = 1